export default __webpack_public_path__ + "static/media/Img8.23cb8cb1.png";